import PropTypes from 'prop-types'

import { NavLink } from 'react-router'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

const activeNavBarLinkStyle = css`
  /* tab underline */
  &:before {
    position: absolute;
    content: '';
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: ${colors.primary35};
  }
`

const StyledNavBarLink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${colors.secondary40};
  font-size: 14px;
  line-height: 48px;
  position: relative;
  white-space: nowrap;
  padding: 0 12px;
  margin: 0;

  &:hover, &:focus {
    color: ${colors.primary40};
    background-color: ${colors.primary100};
    ${activeNavBarLinkStyle}
  }

  &.active {
    color: ${colors.primary35};
    ${activeNavBarLinkStyle}
  }
`

const NavBarLink = ({ name, to }) => {
  return (
    <StyledNavBarLink
      to={to}
      onClick={e => e.target.blur()}
    >
      {name}
    </StyledNavBarLink>
  )
}

NavBarLink.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.string.isRequired,
  ]),
  to: PropTypes.string.isRequired,
}

export default NavBarLink
